/**
 * Dashboard static configuration.
 *
 * HISTORY: this file used to hold ~400 lines of mock analytics data feeding six
 * dashboard widgets (Financial Health, Sales Intelligence, Inventory
 * Intelligence, Cash Flow, Decision Support, Operational Metrics). Those
 * widgets were removed in the July 2026 rebuild; the mock data outlived them
 * and was only ever consumed by src/hooks/useDashboardData.js, which nothing
 * imported. Both were deleted on 2026-08-06.
 *
 * What remains is genuine configuration, not mock data — the file keeps its
 * name only to avoid touching its two importers.
 */

import { subDays, subMonths } from 'date-fns';

const today = new Date();

// Widget grid layout. Ids are the kebab-case widget ids used by
// DashboardContext.widgetVisibility and Dashboard.js WIDGET_PERM_KEY.
export const defaultWidgetLayout = [
  { i: 'executive-summary', x: 0, y: 0,  w: 12, h: 2, minW: 6, minH: 2 },
  { i: 'kpi-cards',         x: 0, y: 2,  w: 12, h: 3, minW: 6, minH: 2 },
  { i: 'sales-overview',      x: 0, y: 5,  w: 12, h: 4, minW: 6, minH: 3 },
  { i: 'money-position',      x: 0, y: 9,  w: 8,  h: 4, minW: 4, minH: 3 },
  { i: 'receivable-payable',  x: 8, y: 9,  w: 4,  h: 4, minW: 3, minH: 3 },
  { i: 'sales-recovery',      x: 0, y: 13, w: 6,  h: 4, minW: 4, minH: 3 },
  { i: 'sales-expense',       x: 6, y: 13, w: 6,  h: 4, minW: 4, minH: 3 },
  { i: 'activity-feed',       x: 0, y: 17, w: 12, h: 3, minW: 6, minH: 2 },
];

// Date Range Presets
export const dateRangePresets = [
  { label: 'Today', value: 'today', startDate: today, endDate: today },
  { label: 'Yesterday', value: 'yesterday', startDate: subDays(today, 1), endDate: subDays(today, 1) },
  { label: 'Last 7 Days', value: 'last7days', startDate: subDays(today, 7), endDate: today },
  { label: 'Last 30 Days', value: 'last30days', startDate: subDays(today, 30), endDate: today },
  { label: 'This Month', value: 'thisMonth', startDate: new Date(today.getFullYear(), today.getMonth(), 1), endDate: today },
  { label: 'Last Month', value: 'lastMonth', startDate: subMonths(new Date(today.getFullYear(), today.getMonth(), 1), 1), endDate: new Date(today.getFullYear(), today.getMonth(), 0) },
  { label: 'This Quarter', value: 'thisQuarter', startDate: new Date(today.getFullYear(), Math.floor(today.getMonth() / 3) * 3, 1), endDate: today },
  { label: 'This Year', value: 'thisYear', startDate: new Date(today.getFullYear(), 0, 1), endDate: today },
  { label: 'Custom', value: 'custom', startDate: null, endDate: null },
];
